var _defs, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusWarningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#eb9c3f;}.b{fill:none;}.c,.d{stroke:none;}.d{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 10,
    cy: 10,
    r: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5.571.715a.5.5,0,0,1,.857,0l5.117,8.528a.5.5,0,0,1-.429.757H.883a.5.5,0,0,1-.429-.757Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 5.999998092651367 2.915468692779541 L 2.649285316467285 8.499994277954102 L 9.350710868835449 8.499994277954102 L 5.999998092651367 2.915468692779541 M 6 0.4718217849731445 C 6.165822505950928 0.4718217849731445 6.331645011901855 0.552739143371582 6.428750038146973 0.714573860168457 L 11.54565048217773 9.242753982543945 C 11.74559783935547 9.575993537902832 11.50552177429199 9.999994277954102 11.11691379547119 9.999994277954102 C 11.11688995361328 9.999994277954102 11.11692333221436 9.999994277954102 11.11690044403076 9.999994277954102 L 0.8830900192260742 9.999994277954102 C 0.4944496154785156 10.00000381469727 0.254389762878418 9.576014518737793 0.454350471496582 9.242753982543945 L 5.571249961853027 0.714573860168457 C 5.668354988098145 0.552739143371582 5.834177494049072 0.4718217849731445 6 0.4718217849731445 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusWarningIcon);
export default __webpack_public_path__ + "static/media/statusWarningIcon.55036d56c67895ee13ef090cf066f2bb.svg";
export { ForwardRef as ReactComponent };